module.exports = __webpack_public_path__ + "img/v_img.5bbb2f14.png";